export const PRODUCT_FIELDS = [
  'image',
  'description',
  'barcode',
  'product_type',
  'ikpu',
  'package_code',
  'tags',
  'type',
  'slug',
  'has_modifier',
  'weight',
  'measurement',
]
